<div class="ui-page-practices-container">
  <ui-grades></ui-grades>
  <ui-categories-tree [practice]="interface.tree"></ui-categories-tree>
</div>
